const BASE_CONST = 'REPORTS_SALES'

// Sales Summary constants
export const REPORTS_SALES_PAGE_REQUEST = `${BASE_CONST}_PAGE_REQUEST`
export const REPORTS_SALES_SUMMARY_REQUEST = `${BASE_CONST}_SUMMARY_REQUEST`
export const REPORTS_SET_LIST_SALES_SUMMARY = 'REPORTS_SET_LIST_SALES_SUMMARY'
export const REPORTS_SALES_EXPORT_SUMMARY = `${BASE_CONST}_EXPORT_SUMMARY`

// Sales Summary constants
export const REPORTS_GROSS_PROFIT_PAGE_REQUEST = `REPORTS_GROSS_PROFIT_PAGE_REQUEST`
export const REPORTS_GROSS_PROFIT_REQUEST = `REPORTS_GROSS_PROFIT_REQUEST`
export const REPORTS_SET_LIST_GROSS_PROFIT = 'REPORTS_SET_LIST_GROSS_PROFIT'
export const REPORTS_SALES_EXPORT_GROSS_PROFIT = `${BASE_CONST}_GROSS_PROFIT`

// Payment Methods constants
export const REPORTS_PAYMENT_METHODS_PAGE_REQUEST = 'REPORTS_PAYMENT_METHODS_PAGE_REQUEST'
export const REPORTS_PAYMENT_METHODS_REQUEST = 'REPORTS_PAYMENT_METHODS_REQUEST'
export const REPORTS_SET_PAYMENT_METHODS = 'REPORTS_SET_PAYMENT_METHODS'
export const REPORTS_SALES_EXPORT_PAYMENT_METHODS = `${BASE_CONST}_EXPORT_PAYMENT_METHODS`

// Item Sales constants
export const REPORTS_ITEM_SALES_PAGE_REQUEST = 'REPORTS_ITEM_SALES_PAGE_REQUEST'
export const REPORTS_ITEM_SALES_REQUEST = 'REPORTS_ITEM_SALES_REQUEST'
export const REPORTS_SET_ITEM_SALES = 'REPORTS_SET_ITEM_SALES'
export const REPORTS_SALES_EXPORT_ITEM_SALES = `${BASE_CONST}_EXPORT_ITEM_SALES`

// Category sales constants
export const REPORTS_CATEGORY_SALES_PAGE_REQUEST = 'REPORTS_CATEGORY_SALES_PAGE_REQUEST'
export const REPORTS_CATEGORY_SALES_REQUEST = 'REPORTS_CATEGORY_SALES_REQUEST'
export const REPORTS_SET_CATEGORY_SALES = 'REPORTS_SET_CATEGORY_SALES'
export const REPORTS_SALES_EXPORT_CATEGORY_SALES = `${BASE_CONST}_EXPORT_CATEGORY_SALES`

// Modifier sales constants
export const REPORTS_MODIFIER_SALES_PAGE_REQUEST = 'REPORTS_MODIFIER_SALES_PAGE_REQUEST'
export const REPORTS_MODIFIER_SALES_REQUEST = 'REPORTS_MODIFIER_SALES_REQUEST'
export const REPORTS_SET_MODIFIER_SALES = 'REPORTS_SET_MODIFIER_SALES'
export const REPORTS_SALES_EXPORT_MODIFIER_SALES = `${BASE_CONST}_EXPORT_MODIFIER_SALES`

// Discounts constants
export const REPORTS_DISCOUNTS_PAGE_REQUEST = 'REPORTS_DISCOUNTS_PAGE_REQUEST'
export const REPORTS_DISCOUNTS_REQUEST = 'REPORTS_DISCOUNTS_REQUEST'
export const REPORTS_SET_DISCOUNTS = 'REPORTS_SET_DISCOUNTS'
export const REPORTS_SALES_EXPORT_DISCOUNTS = `${BASE_CONST}_EXPORT_DISCOUNTS`

// Taxes constants
export const REPORTS_TAXES_PAGE_REQUEST = 'REPORTS_TAXES_PAGE_REQUEST'
export const REPORTS_TAXES_REQUEST = 'REPORTS_TAXES_REQUEST'
export const REPORTS_SET_TAXES = 'REPORTS_SET_TAXES'
export const REPORTS_SALES_EXPORT_TAXES = `${BASE_CONST}_EXPORT_TAXES`

// Gratuity constants
export const REPORTS_GRATUITY_PAGE_REQUEST = 'REPORTS_GRATUITY_PAGE_REQUEST'
export const REPORTS_GRATUITY_REQUEST = 'REPORTS_GRATUITY_REQUEST'
export const REPORTS_SET_GRATUITY = 'REPORTS_SET_GRATUITY'
export const REPORTS_SALES_EXPORT_GRATUITY = `${BASE_CONST}_EXPORT_GRATUITY`

// Collected By constants
export const REPORTS_COLLECTEDBY_PAGE_REQUEST = 'REPORTS_COLLECTEDBY_PAGE_REQUEST'
export const REPORTS_COLLECTEDBY_REQUEST = 'REPORTS_COLLECTEDBY_REQUEST'
export const REPORTS_SET_COLLECTEDBY = 'REPORTS_SET_COLLECTEDBY'
export const REPORTS_SALES_EXPORT_COLECTEDBY = `${BASE_CONST}_EXPORT_COLECTEDBY`

// Served By constants
export const REPORTS_SERVEDBY_PAGE_REQUEST = 'REPORTS_SERVEDBY_PAGE_REQUEST'
export const REPORTS_SERVEDBY_REQUEST = 'REPORTS_SERVEDBY_REQUEST'
export const REPORTS_SET_SERVEDBY = 'REPORTS_SET_SERVEDBY'
export const REPORTS_SALES_EXPORT_SERVEDBY = `${BASE_CONST}_EXPORT_SERVEDBY`

// Filter by date constants
export const REPORTS_SALES_SUMMARY_CHANGE_DATE = `${BASE_CONST}_SUMMARY_CHANGE_DATE`
export const REPORTS_SALES_SUMMARY_SET_START_END_DATE = `${BASE_CONST}_SUMMARY_SET_START_END_DATE`

export const REPORTS_SALES_GROSS_PROFIT_CHANGE_DATE = `${BASE_CONST}_GROSS_PROFIT_CHANGE_DATE`
export const REPORTS_SALES_GROSS_PROFIT_SET_START_END_DATE = `${BASE_CONST}_GROSS_PROFIT_SET_START_END_DATE`

export const REPORTS_SALES_PAYMENT_METHODS_CHANGE_DATE = `${BASE_CONST}_PAYMENT_METHODS_CHANGE_DATE`
export const REPORTS_SALES_PAYMENT_METHODS_SET_START_END_DATE = `${BASE_CONST}_PAYMENT_METHODS_SET_START_END_DATE`

export const REPORTS_SALES_ITEM_SALES_CHANGE_DATE = `${BASE_CONST}_ITEM_SALES_CHANGE_DATE`
export const REPORTS_SALES_ITEM_SALES_SET_START_END_DATE = `${BASE_CONST}_ITEM_SALES_SET_START_END_DATE`

export const REPORTS_SALES_CATEGORY_SALES_CHANGE_DATE = `${BASE_CONST}_CATEGORY_SALES_CHANGE_DATE`
export const REPORTS_SALES_CATEGORY_SALES_SET_START_END_DATE = `${BASE_CONST}_CATEGORY_SALES_SET_START_END_DATE`

export const REPORTS_SALES_MODIFIER_SALES_CHANGE_DATE = `${BASE_CONST}_MODIFIER_SALES_CHANGE_DATE`
export const REPORTS_SALES_MODIFIER_SALES_SET_START_END_DATE = `${BASE_CONST}_MODIFIER_SALES_SET_START_END_DATE`

export const REPORTS_SALES_DISCOUNTS_CHANGE_DATE = `${BASE_CONST}_DISCOUNTS_CHANGE_DATE`
export const REPORTS_SALES_DISCOUNTS_SET_START_END_DATE = `${BASE_CONST}_DISCOUNTS_SET_START_END_DATE`

export const REPORTS_SALES_TAXES_CHANGE_DATE = `${BASE_CONST}_TAXES_CHANGE_DATE`
export const REPORTS_SALES_TAXES_SET_START_END_DATE = `${BASE_CONST}_TAXES_SET_START_END_DATE`

export const REPORTS_SALES_GRATUITY_CHANGE_DATE = `${BASE_CONST}_GRATUITY_CHANGE_DATE`
export const REPORTS_SALES_GRATUITY_SET_START_END_DATE = `${BASE_CONST}_GRATUITY_SET_START_END_DATE`

export const REPORTS_SALES_COLLECTEDBY_CHANGE_DATE = `${BASE_CONST}_COLLECTEDBY_CHANGE_DATE`
export const REPORTS_SALES_COLLECTEDBY_SET_START_END_DATE = `${BASE_CONST}_COLLECTEDBY_SET_START_END_DATE`

export const REPORTS_SALES_SERVEDBY_CHANGE_DATE = `${BASE_CONST}_SERVEDBY_CHANGE_DATE`
export const REPORTS_SALES_SERVEDBY_SET_START_END_DATE = `${BASE_CONST}_SERVEDBY_SET_START_END_DATE`

// Filter by outlet constants
export const REPORTS_SALES_SUMMARY_CHANGE_OUTLET = `${BASE_CONST}_SUMMARY_CHANGE_OUTLET`
export const REPORTS_SALES_GROSS_PROFIT_CHANGE_OUTLET = `${BASE_CONST}_GROSS_PROFIT_CHANGE_OUTLET`
export const REPORTS_SALES_PAYMENT_METHODS_CHANGE_OUTLET = `${BASE_CONST}_PAYMENT_METHODS_CHANGE_OUTLET`
export const REPORTS_SALES_ITEM_SALES_CHANGE_OUTLET = `${BASE_CONST}_ITEM_SALES_CHANGE_OUTLET`
export const REPORTS_SALES_CATEGORY_SALES_CHANGE_OUTLET = `${BASE_CONST}_CATEGORY_SALES_CHANGE_OUTLET`
export const REPORTS_SALES_MODIFIER_SALES_CHANGE_OUTLET = `${BASE_CONST}_MODIFIER_SALES_CHANGE_OUTLET`
export const REPORTS_SALES_DISCOUNTS_CHANGE_OUTLET = `${BASE_CONST}_DISCOUNTS_CHANGE_OUTLET`
export const REPORTS_SALES_TAXES_CHANGE_OUTLET = `${BASE_CONST}_TAXES_CHANGE_OUTLET`
export const REPORTS_SALES_GRATUITY_CHANGE_OUTLET = `${BASE_CONST}_GRATUITY_CHANGE_OUTLET`
export const REPORTS_SALES_COLLECTEDBY_CHANGE_OUTLET = `${BASE_CONST}_COLLECTEDBY_CHANGE_OUTLET`
export const REPORTS_SALES_SERVEDBY_CHANGE_OUTLET = `${BASE_CONST}_SERVEDBY_CHANGE_OUTLET`

export const REPORTS_SALES_SET_OUTLETS = `${BASE_CONST}_SET_OUTLETS`

export const REPORTS_SALES_SHOW_LOADING_SPINNER = `${BASE_CONST}_SHOW_LOADING_SPINNER`



// WEBPACK FOOTER //
// ./app/actions/reports/sales/constants.js